module.exports = __webpack_public_path__ + "static/img/gen_1_old.a5d2d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gen_1_old.png
// module id = /Fhj
// module chunks = 1